export default __webpack_public_path__ + "static/media/icon_hallinto_valmis.e2f25d24.svg";